import { z as zod } from 'zod';

import { BaseDtoSchema } from '@enterprise/types';

/**
 * Zod schema for validating Tag Category objects.
 *
 * Extends the `BaseDtoSchema` with additional fields specific to tag categories.
 *
 * @property {string} [ancestry] - Optional. The ancestry path of the tag category.
 * @property {string} [color] - Optional. The color associated with the tag category.
 * @property {string} [icon] - Optional. The icon representing the tag category.
 * @property {string} [longDescription] - Optional. A detailed description of the tag category.
 * @property {string} name - The name of the tag category.
 * @property {number} [parentCategoryId] - Optional. The ID of the parent tag category.
 * @property {string} [shortDescription] - Optional. A brief description of the tag category.
 */
export const TagCategorySchema = BaseDtoSchema.extend({
  ancestry: zod.string().optional(),
  color: zod.string().optional(),
  icon: zod.string().optional(),
  longDescription: zod.string().optional(),
  name: zod.string(),
  parentCategoryId: zod.number().optional(),
  shortDescription: zod.string().optional(),
});
